<template>
  <div id="index" class="index" :class="header_notification ? 'space' : ''">
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="side" :class="{ collapsed: isSideMenuClosed }">
      <sidemenu ref="sidemenu" />
    </div>
    <div :class="['main', window_width < 1200 ? 'medium_window' : '', collapse_menu ? 'expanded' : '']" id="main">
      <headermenu @collapse="collapse" class="header" />
      <router-view @sidemenuScroll="sidemenuScroll"></router-view>
    </div>
    <transition name="fade">
      <div v-if="activate == 1" class="trial-expiration" :class="header_notification ? 'header-notification-space-70' : ''">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />トライアル・契約が終了しました。
        <a
          v-if="!hasUpdateParam"
          class="pointer"
          :href="upgradeLink"
          target="_blank"
        >アップグレード</a>
        <router-link v-else class="pointer" :to="upgradeLink">アップグレード</router-link>
        して利用を再開しましょう。
      </div>
    </transition>
    <nps v-if="header_notification"/>
    <unpermittedDrawer :unpermitted_drawer.sync="unpermitted_drawer" />
  </div>
</template>

<script>
import sidemenu from "./sidemenu/sidemenu.vue";
import headermenu from "./headermenu.vue";
import nps from "./nps.vue";
import unpermittedDrawer from "./unpermitted_drawer.vue"
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "index",
  components: {
    sidemenu,
    headermenu,
    nps,
    unpermittedDrawer,
    UserTokenSiteName
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      window_width: "",
      collapse_menu: false,
      notification: false,
      isOem: false
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    intercom_hash() {
      return this.$store.state.intercom_hash;
    },
    client_name() {
      return this.$store.state.client_name;
    },
    person_name() {
      return this.$store.state.person_name;
    },
    email() {
      return this.$store.state.member_info.email;
    },
    activate() {
      return this.$store.state.activate;
    },
    drawer() {
      return this.$store.state.drawer;
    },
    old_app() {
      return this.$store.state.old_app;
    },
    app_ver() {
      return this.$store.state.app_ver;
    },
    mode() {
      return this.$store.state.mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    unpermitted_drawer() {
      return this.$store.state.unpermitted_drawer;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
    hasUpdateParam() {
      return this.$route.query.update === "6UgWG7ejgXPaL4rF";
    },
    upgradeLink() {
      return this.hasUpdateParam
        ? "/setting/upgrade"
        : "https://share.hsforms.com/1XxQIdXE-TXuUbflmQrreVg3fql7";
    },
  },
  created(){
    this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
  },
  mounted() {
    document.documentElement.style.overflow = "auto";
    this.browserCheck();
    this.mobileCheck();
    if (this.$route.path === "/") {
      this.$router.push({ path: "/dashboard" });
    }
    window.addEventListener("resize", this.calcWindowSize);
    this.calcWindowSize();
  },
  methods: {
    browserCheck() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("msie") != -1 || userAgent.indexOf("trident") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("edg") != -1) {
        console.log("");
      } else if (userAgent.indexOf("chrome") != -1) {
        console.log("");
      } else if (userAgent.indexOf("safari") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("firefox") != -1) {
        console.log("");
      } else if (userAgent.indexOf("opera") != -1) {
        console.log("");
      } else {
        console.log("");
      }
    },
    mobileCheck() {
      if (this.$mq == "sp") {
        this.$router.push({ path: "/incompatible" });
      }
    },
    dashboard() {
      this.$router.push("/dashboard");
    },
    sidemenuScroll(sns_type) {
      this.$refs.sidemenu.sidemenuScroll(sns_type);
    },
    intercom() {
      this.$intercom.boot({
        user_id: this.user_token,
        user_hash: this.intercom_hash,
        name: this.client_name + " " + this.person_name,
        email: this.email,
        app_type: "DATABASE",
        app_ver: this.app_ver,
      });
      // this.$intercom.show();
    },
    calcWindowSize() {
      this.window_width = window.innerWidth;
    },
    collapse() {
      this.collapse_menu = !this.collapse_menu;
    },
    notificationCheck() {
      if (this.activate == null) {
        this.notification = true;
      } else {
        this.notification = false;
      }
    },
    updateSiteInfo({isOem}) {
      if(isOem === false) this.intercom();
    },
  },
  watch: {
    $route(to, from) {
      if (to.name == "index") {
        this.dashboard();
      }
      if (!to.name.match(/Drawer/)) {
        document.documentElement.style.overflow = "auto";
      }
      if (!to.name.match(/Drawer/) && !from.name.match(/Drawer/)) {
        this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
      }
    },
    email(email) {
      this.$intercom.update({ email });
    },
    activate() {
      this.notificationCheck();
    },
    old_app() {
      // アプリのバージョンが最新でない場合リフレッシュ
      if (this.old_app && this.mode == "prod") {
        const reloadedVersion = sessionStorage.getItem("reech.reloadedVersion");
        if (reloadedVersion === this.app_ver) return;
        sessionStorage.setItem("reech.reloadedVersion", this.app_ver);
        this.$nextTick(() => {
          location.reload(true);
        });
      }
    },
  },
};
</script>
